import React, { useState, useEffect } from 'react'
import { Alert, Modal } from 'antd'
import { Texto, GraviButton, BBDTag, LoadingAnimation, Horizontal, Vertical } from '@gravitate-js/excalibrr'
import { CheckCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons'
import { StatusMessageGrid } from './Grid'
import { UploadStatusCards } from './StatusCards'
import uploadAnim from '../../../assets/Animation/upload_anim.json'
import { responseStatuses } from './utils/uploadStatus'

export const UploadStatusModal = ({
  uploadStatusModalVisible,
  setUploadStatusModalVisible,
  statusResponse,
  isUploading,
}) => {
  const [statusView, setStatusView] = useState()

  useEffect(() => {
    if (statusResponse?.error_count > 0) {
      setStatusView('error')
    } else if (statusResponse?.warning_count > 0) {
      setStatusView('warning')
    } else if (statusResponse?.warning_count === 0 && statusResponse?.error_count === 0) {
      setStatusView('')
    }
  }, [statusResponse])
  return (
    <Modal
      closable={!isUploading}
      maskClosable={!isUploading}
      footer={
        !isUploading && (
          <GraviButton
            buttonText='Dismiss'
            onClick={() => {
              setUploadStatusModalVisible(false)
            }}
          />
        )
      }
      title={<Texto>Upload Status</Texto>}
      open={uploadStatusModalVisible}
      onCancel={() => {
        setUploadStatusModalVisible(false)
      }}
      width={1000}
    >
      <ModalContents
        statusResponse={statusResponse}
        statusView={statusView}
        setStatusView={setStatusView}
        loading={isUploading}
      />
    </Modal>
  )
}
const ModalContents = ({ statusResponse, statusView, setStatusView, loading }) => {
  if (loading)
    return (
      <div className='vertical-flex-center'>
        <LoadingAnimation
          title='Uploading Spreadsheet'
          message='This might take a minute. Please wait until the upload results are ready.'
          animationData={uploadAnim}
          loop
          height={250}
        />
      </div>
    )
  if (!statusResponse) return null

  return (
    <Vertical gap={16}>
      <StatusHeader statusResponse={statusResponse} />

      <UploadStatusCards statusResponse={statusResponse} statusView={statusView} />
      <StatusMessageGrid setStatusView={setStatusView} statusView={statusView} statusResponse={statusResponse} />
    </Vertical>
  )
}
const StatusHeader = ({ statusResponse }) => {
  const isError = statusResponse.updated_count === 0
  if (isError) {
    return <Alert description={statusResponse.message} message='Upload Error' type='error' showIcon />
  }
  return (
    <Alert
      type='success'
      message='Upload Complete'
      description={statusResponse.message}
      className='flex items-center'
      showIcon
    />
  )
}
